export const EXCMCASETYPE_DELETE_RESET = 'EXCMCASETYPE_DELETE_RESET'
export const EXCMCASETYPE_DELETE_SET_ERROR = 'EXCMCASETYPE_DELETE_SET_ERROR'
export const EXCMCASETYPE_DELETE_SET_DELETED = 'EXCMCASETYPE_DELETE_SET_DELETED'
export const EXCMCASETYPE_DELETE_TOGGLE_LOADING = 'EXCMCASETYPE_DELETE_TOGGLE_LOADING'
